import {inject} from '@angular/core';
import {CanMatchFn} from '@angular/router';
import {SessionService} from '@q9elements/ui-kit/common';
import {catchError, of, tap} from 'rxjs';

import {LOGIN_PREFERENCES} from '../../profile/models/profile';
import {AuthDaoService} from '../services/auth-dao.service';
import {Q9maCookieService} from '../services/cookie.service';

export const OAuth2Guard: CanMatchFn = () => {
  const sessionService = inject(SessionService);
  const authDaoService = inject(AuthDaoService);
  const cookieService = inject(Q9maCookieService);

  const user = sessionService.user()!;
  const isTokenValid = cookieService.isTokenValid();

  if (!isTokenValid || user?.state !== 'active') {
    return true;
  }

  const params = new URLSearchParams(window.location.search);
  const areValidParams = validateOAuthParams(params);

  if (!areValidParams) {
    return true;
  }

  const redirectUrl = params.get('redirect_uri');
  const orgId = params.get('org_id');

  return authDaoService.validateRedirectUrl(redirectUrl!, orgId!).pipe(
    tap(() => {
      const token = cookieService.getToken();

      window.location.href = `${redirectUrl}?code=${token}`;
    }),
    catchError(() => of(true))
  );
};

function validateOAuthParams(params: URLSearchParams): boolean {
  const source = params.get('source') as LOGIN_PREFERENCES;
  const redirect_uri = params.get('redirect_uri');

  if (!redirect_uri || !source) {
    return false;
  }

  if (![LOGIN_PREFERENCES.SALESFORCE].includes(source)) {
    return false;
  }

  const org_id = params.get('org_id');

  if (!org_id && source === LOGIN_PREFERENCES.SALESFORCE) {
    return false;
  }

  return true;
}
